module.exports = __webpack_public_path__ + "img/ski_cos2.1d7bb5d1.png";